import React from "react"
import styled from "@emotion/styled"

import { colors } from "utils/styles"
import Link from "components/shared/Link"

const Footer = styled.footer`
  margin-top: 50px;
  height: 120px;
  background-color: #f8f9fa;
  position: relative;
`

const Links = styled.div`
  position: absolute;
  bottom: 50px;
  right: 50px;
`

const FooterLink = styled(Link)`
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
  color: ${colors.gray700};
  font-weight: 700;
  margin-left: 20px;
  font-size: 0.85rem;
`

export default ({ displayFooter }) => {
  return (
    <>
      {displayFooter && (
        <Footer>
          <Links>
            <FooterLink href="mailto:hi@itty.me">Contact</FooterLink>
            <FooterLink to="/legal/terms">Terms</FooterLink>
            <FooterLink to="/legal/privacy">Privacy</FooterLink>
          </Links>
        </Footer>
      )}
    </>
  )
}
